export default function FitScoreDisplay({ company, showDetailed = false }) {
  const compositeFit = (company.locationMatch + company.techMatch + company.businessFit + company.hiringPattern) / 4;

  const getScoreColor = (score) => {
    if (score >= 4) return '#98FB98';
    if (score >= 3) return 'rgba(152, 251, 152, 0.7)';
    return 'rgba(152, 251, 152, 0.4)';
  };

  const scoreDetails = [
    { label: 'Location', value: company.locationMatch, description: 'Geographic proximity to job posting' },
    { label: 'Tech Stack', value: company.techMatch, description: 'Technology and tools alignment' },
    { label: 'Business Fit', value: company.businessFit, description: 'Industry and company profile match' },
    { label: 'Hiring Pattern', value: company.hiringPattern, description: 'Recruitment behavior indicators' }
  ];

  if (!showDetailed) {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '12px' }}>
        {scoreDetails.map((detail, idx) => (
          <div key={idx} style={{ textAlign: 'center' }}>
            <div style={{
              fontSize: '20px',
              fontWeight: '700',
              color: getScoreColor(detail.value),
              textShadow: `0 0 8px ${getScoreColor(detail.value)}`
            }}>
              {detail.value}/5
            </div>
            <div style={{ fontSize: '11px', color: '#F5F5F5', marginTop: '4px', fontFamily: 'VT323, monospace' }}>
              {detail.label}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div style={{
      background: 'rgba(34, 139, 34, 0.15)',
      padding: '20px',
      borderRadius: '12px',
      border: '2px solid rgba(152, 251, 152, 0.3)',
      marginTop: '16px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <h5 style={{
          fontSize: '16px',
          fontWeight: '700',
          color: '#98FB98',
          margin: 0,
          textShadow: '0 0 10px rgba(152, 251, 152, 0.6)'
        }}>
          Detailed Fit Analysis
        </h5>
        <div style={{
          fontSize: '18px',
          fontWeight: '700',
          color: '#98FB98',
          textShadow: '0 0 12px rgba(152, 251, 152, 0.7)'
        }}>
          Overall: {compositeFit.toFixed(1)}/5
        </div>
      </div>

      <div style={{ display: 'grid', gap: '16px' }}>
        {scoreDetails.map((detail, idx) => (
          <div key={idx} style={{
            background: 'rgba(34, 139, 34, 0.2)',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid rgba(152, 251, 152, 0.25)'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '12px'
            }}>
              <div>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '700',
                  color: '#98FB98',
                  marginBottom: '4px'
                }}>
                  {detail.label}
                </div>
                <div style={{
                  fontSize: '12px',
                  color: 'rgba(152, 251, 152, 0.75)',
                  lineHeight: '1.5'
                }}>
                  {detail.description}
                </div>
              </div>
              <div style={{
                fontSize: '28px',
                fontWeight: '700',
                color: getScoreColor(detail.value),
                textShadow: `0 0 10px ${getScoreColor(detail.value)}`,
                minWidth: '60px',
                textAlign: 'right'
              }}>
                {detail.value}/5
              </div>
            </div>

            <div style={{
              height: '8px',
              background: 'rgba(34, 139, 34, 0.3)',
              borderRadius: '4px',
              overflow: 'hidden'
            }}>
              <div style={{
                width: `${(detail.value / 5) * 100}%`,
                height: '100%',
                background: `linear-gradient(90deg, ${getScoreColor(detail.value)}, rgba(152, 251, 152, 0.5))`,
                borderRadius: '4px',
                boxShadow: `0 0 8px ${getScoreColor(detail.value)}`,
                transition: 'width 0.3s ease'
              }} />
            </div>
          </div>
        ))}
      </div>

      <div style={{
        marginTop: '20px',
        padding: '16px',
        background: 'rgba(34, 139, 34, 0.25)',
        borderRadius: '8px',
        border: '1px solid rgba(152, 251, 152, 0.4)'
      }}>
        <div style={{ fontSize: '13px', fontWeight: '600', color: '#98FB98', marginBottom: '8px' }}>
          Scoring Methodology
        </div>
        <div style={{ fontSize: '12px', color: 'rgba(152, 251, 152, 0.85)', lineHeight: '1.6' }}>
          Weighted composite: (Location×8 + Tech Stack×10 + Business Fit×7 + Hiring Pattern×6) / 31 × 100
          <br />
          Confidence Score: {company.confidence}%
        </div>
      </div>
    </div>
  );
}
